import { call } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import history from "govHistory"
const { pathname } = document.location

export function* handlingPutApiError(error) {
  if (error.message === "invalid token") {
    // リフレッシュトークンが無効な場合
    yield call(DLogin, { prompt: true })
  } else if (error && error.message === "dauth error") {
    // サーバエラーなどでトークンリフレッシュに失敗した場合
    yield call(history.push, "/error", { pathname })
  } else {
    // APIの処理に失敗した場合
    yield call(history.push, "/error", { pathname })
  }
}
